import styled, { css } from "styled-components";
import { rgba } from "polished";

export const Container = styled.div`
  position: relative;
`;

export const Title = styled.h2`
  ${({ theme }) => css`
    font-size: 0.9rem;
    color: ${theme.colors.gray400};
    text-transform: uppercase;
    letter-spacing: 0.1rem;
    margin-bottom: 1rem;
  `}
`;

export const Workspace = styled.div`
  ${({ theme, isNew }) => css`
    padding: 0.7rem;
    height: 3.3rem;
    border-radius: 0.5rem;
    border: 0.1rem solid ${theme.colors.white};
    transition: 0.3s;

    display: flex;
    gap: 0.7rem;
    align-items: center;
    justify-content: space-between;

    color: ${theme.colors.white};
    background-color: ${isNew
      ? theme.colors?.primary.active
      : theme.colors.dark};
    cursor: pointer;

    position: relative;

    &:hover {
      background-color: ${isNew
        ? theme.colors?.primary.hover
        : theme.colors.darkeen.hover};
    }
  `}
`;

export const Overlay = styled.div`
  ${({ theme }) => css`
    position: fixed;
    top: 0;
    left: 0;

    width: 100%;
    height: 100vh;
    background-color: ${rgba(theme.colors.black, 0.9)};

    z-index: 1;
  `}
`;

export const WorkspaceContent = styled.div`
  position: absolute;

  top: 2rem;
  left: 50%;
  transform: translateX(-50%);

  width: 26rem;
  padding: 0 2rem;
  z-index: 2;
`;

export const Workspaces = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 0.5rem;
`;

export const WorkspaceName = styled.h3`
  ${({ theme }) => css`
    font-size: 1rem;
    color: ${theme.colors.white};
    font-weight: 600;
  `}
`;
